export type LocaleCode = 'es' | 'en' | 'pt' | 'fr' | 'de' | 'it' | 'ca' | 'ja' | 'zh' | 'ko';

export interface Locale {
  code: LocaleCode;
  label: string;
  eyebrow: string;
  l1: string;
  l2: string;
  steps: {
    brand: string;
    arch: string;
    fe: string;
    qa: string;
    launch: string;
    pending: string;
    eta: string;
  };
  statusOverall: string;
  statusTitle: string;
  statusEta: string;
  deployChip: string;
}

export const LOCALES: readonly Locale[] = [
  {
    code: 'es',
    label: 'ES · Español',
    eyebrow: 'SITIO EN CONSTRUCCIÓN',
    l1: 'Estamos construyendo',
    l2: 'algo nuevo.',
    steps: {
      brand: 'Marca · sistema visual',
      arch: 'Arquitectura · contenido',
      fe: 'Frontend · componentes',
      qa: 'QA · accesibilidad & perf',
      launch: 'Lanzamiento',
      pending: 'pendiente',
      eta: 'próximamente',
    },
    statusOverall: 'Avance total',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'Próximamente',
    deployChip: 'main → prod · próximamente',
  },
  {
    code: 'en',
    label: 'EN · English',
    eyebrow: 'SITE UNDER CONSTRUCTION',
    l1: "We're building",
    l2: 'something new.',
    steps: {
      brand: 'Brand · visual system',
      arch: 'Architecture · content',
      fe: 'Frontend · components',
      qa: 'QA · a11y & perf',
      launch: 'Launch',
      pending: 'pending',
      eta: 'soon',
    },
    statusOverall: 'Overall progress',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'Coming soon',
    deployChip: 'main → prod · coming soon',
  },
  {
    code: 'pt',
    label: 'PT · Português',
    eyebrow: 'SITE EM CONSTRUÇÃO',
    l1: 'Estamos a construir',
    l2: 'algo novo.',
    steps: {
      brand: 'Marca · sistema visual',
      arch: 'Arquitetura · conteúdo',
      fe: 'Frontend · componentes',
      qa: 'QA · acessibilidade & perf',
      launch: 'Lançamento',
      pending: 'pendente',
      eta: 'em breve',
    },
    statusOverall: 'Progresso total',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'Em breve',
    deployChip: 'main → prod · em breve',
  },
  {
    code: 'fr',
    label: 'FR · Français',
    eyebrow: 'SITE EN CONSTRUCTION',
    l1: 'Nous construisons',
    l2: 'quelque chose de neuf.',
    steps: {
      brand: 'Marque · système visuel',
      arch: 'Architecture · contenu',
      fe: 'Frontend · composants',
      qa: 'QA · a11y & perf',
      launch: 'Lancement',
      pending: 'en attente',
      eta: 'bientôt',
    },
    statusOverall: 'Avancement global',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'Bientôt',
    deployChip: 'main → prod · bientôt',
  },
  {
    code: 'de',
    label: 'DE · Deutsch',
    eyebrow: 'SEITE IM AUFBAU',
    l1: 'Wir bauen gerade',
    l2: 'etwas Neues.',
    steps: {
      brand: 'Marke · Designsystem',
      arch: 'Architektur · Inhalt',
      fe: 'Frontend · Komponenten',
      qa: 'QA · A11y & Perf',
      launch: 'Launch',
      pending: 'ausstehend',
      eta: 'demnächst',
    },
    statusOverall: 'Gesamtfortschritt',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'Demnächst',
    deployChip: 'main → prod · demnächst',
  },
  {
    code: 'it',
    label: 'IT · Italiano',
    eyebrow: 'SITO IN COSTRUZIONE',
    l1: 'Stiamo costruendo',
    l2: 'qualcosa di nuovo.',
    steps: {
      brand: 'Brand · sistema visivo',
      arch: 'Architettura · contenuti',
      fe: 'Frontend · componenti',
      qa: 'QA · accessibilità & perf',
      launch: 'Lancio',
      pending: 'in sospeso',
      eta: 'in arrivo',
    },
    statusOverall: 'Avanzamento totale',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'In arrivo',
    deployChip: 'main → prod · in arrivo',
  },
  {
    code: 'ca',
    label: 'CA · Català',
    eyebrow: 'LLOC EN CONSTRUCCIÓ',
    l1: 'Estem construint',
    l2: 'quelcom nou.',
    steps: {
      brand: 'Marca · sistema visual',
      arch: 'Arquitectura · contingut',
      fe: 'Frontend · components',
      qa: 'QA · accessibilitat & perf',
      launch: 'Llançament',
      pending: 'pendent',
      eta: 'ben aviat',
    },
    statusOverall: 'Progrés total',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: 'Ben aviat',
    deployChip: 'main → prod · ben aviat',
  },
  {
    code: 'ja',
    label: 'JA · 日本語',
    eyebrow: 'サイト構築中',
    l1: '新しいものを',
    l2: 'つくっています。',
    steps: {
      brand: 'ブランド · ビジュアルシステム',
      arch: 'アーキテクチャ · コンテンツ',
      fe: 'フロントエンド · コンポーネント',
      qa: 'QA · アクセシビリティ & 性能',
      launch: 'ローンチ',
      pending: '待機中',
      eta: '近日',
    },
    statusOverall: '全体の進捗',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: '近日公開',
    deployChip: 'main → prod · 近日公開',
  },
  {
    code: 'zh',
    label: 'ZH · 中文',
    eyebrow: '网站建设中',
    l1: '我们正在打造',
    l2: '全新的内容。',
    steps: {
      brand: '品牌 · 视觉系统',
      arch: '架构 · 内容',
      fe: '前端 · 组件',
      qa: 'QA · 无障碍与性能',
      launch: '上线',
      pending: '待办',
      eta: '即将',
    },
    statusOverall: '总体进度',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: '即将上线',
    deployChip: 'main → prod · 即将上线',
  },
  {
    code: 'ko',
    label: 'KO · 한국어',
    eyebrow: '사이트 준비 중',
    l1: '새로운 것을',
    l2: '만들고 있어요.',
    steps: {
      brand: '브랜드 · 비주얼 시스템',
      arch: '아키텍처 · 콘텐츠',
      fe: '프론트엔드 · 컴포넌트',
      qa: 'QA · 접근성 & 성능',
      launch: '런칭',
      pending: '대기 중',
      eta: '곧',
    },
    statusOverall: '전체 진행률',
    statusTitle: 'DSOFTSTUDIO.COM · v2.0',
    statusEta: '곧 출시',
    deployChip: 'main → prod · 곧 출시',
  },
] as const;

export const HEADLINE_INTERVAL_MS = 8000;
export const HEADLINE_FADE_MS = 320;
